import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import resultImg from "../../styles/images/img_change_result.png";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../../components/hooks/authFunc";
import { amoActions } from "../../store/slices/amoSlice";
import { replaceCommas } from "../../components/hooks/basicFunc";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";
const AmoChangeResult = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const type = location.state !== null ? location.state.type : "";
  const accessToken = getToken();
  const swapMupToAmoResult = useSelector(
    (state) => state.amo.swapMupToAmoResult
  );
  const swapAmoToMupResult = useSelector(
    (state) => state.amo.swapAmoToMupResult
  );
  const swapConfirmResult = useSelector((state) => state.amo.swapConfirmResult);

  const getData = () => {
    const wallet = location.state !== null ? location.state.wallet : "";
    const params = {
      txid: swapConfirmResult.info?.tx,
      wallet: wallet,
    };
    dispatch(amoActions.fetchSwapAmoToMup({ params, accessToken }));
  };

  useEffect(() => {
    if (type == "toPoint") {
      getData();
    }
  }, []);
  return (
    <OnlyHeaderLayout
      title={type == "toAmo" ? "교환 및 전송 완료" : "교환 완료"}
    >
      <Section className="minPaddingTop">
        {type == "toAmo" && (
          <Content>
            <TextDiv>
              <h3>뮤 포인트가 AMO 코인으로 교환되었습니다.</h3>
            </TextDiv>
            {swapMupToAmoResult.info && (
              <>
                <ResultInfo>
                  <ul>
                    <li>
                      <LiTitle>교환요청</LiTitle>
                      <p>뮤 포인트 {`>`} AMO</p>
                    </li>
                    <li>
                      <LiTitle>교환수량</LiTitle>
                      <p>{swapMupToAmoResult.info.mup} MUP</p>
                    </li>
                    <li>
                      <LiTitle>AMO코인시세</LiTitle>
                      <p>{swapMupToAmoResult.info.amoPrice} 원</p>
                    </li>
                    <li>
                      <LiTitle>AMO수량</LiTitle>
                      <p>{swapMupToAmoResult.info.amo} AMO</p>
                    </li>
                    <li>
                      <LiTitle>수수료</LiTitle>
                      <p>{swapMupToAmoResult.info.fee} MUP (vat 포함)</p>
                    </li>
                    <li>
                      <LiTitle>TX ID</LiTitle>
                      <p
                        className="tx"
                        onClick={() => {
                          window.open(
                            `https://klaytnscope.com/tx/${swapMupToAmoResult.info.tx}`
                          );
                        }}
                      >
                        {swapMupToAmoResult.info.tx}
                      </p>
                    </li>
                  </ul>
                </ResultInfo>
                <ImgWrap imgwidth="13.8" margintop="5.5">
                  <img src={resultImg} alt="" />
                </ImgWrap>
              </>
            )}
          </Content>
        )}
        {type == "toPoint" && (
          <Content>
            <TextDiv>
              <h3>AMO 코인이 뮤 포인트로 교환되었습니다.</h3>
            </TextDiv>
            {swapConfirmResult && swapAmoToMupResult.info && (
              <>
                <ResultInfo>
                  <ul>
                    <li>
                      <LiTitle>교환요청</LiTitle>
                      <p>AMO {`>`} 뮤 포인트</p>
                    </li>
                    <li>
                      <LiTitle>입금된 수량</LiTitle>
                      <p>{swapAmoToMupResult.info.amo} AMO</p>
                    </li>
                    <li>
                      <LiTitle>AMO코인시세</LiTitle>
                      <p>{swapAmoToMupResult.info.price} 원</p>
                    </li>
                    <li>
                      <LiTitle>뮤포인트 수량</LiTitle>
                      <p>{replaceCommas(swapAmoToMupResult.info?.mup)} MUP</p>
                    </li>

                    <li>
                      <LiTitle>수수료</LiTitle>
                      <p>{swapAmoToMupResult.info.includeVat} MUP (vat 포함)</p>
                    </li>
                    <li>
                      <LiTitle>보유 뮤포인트</LiTitle>
                      <p>
                        {replaceCommas(swapAmoToMupResult.info?.balance)} MUP
                      </p>
                    </li>
                  </ul>
                </ResultInfo>
                <ImgWrap imgwidth="13.8" margintop="6.5">
                  <img src={resultImg} alt="" />
                </ImgWrap>
              </>
            )}
          </Content>
        )}
        {type == "" && (
          <Content>
            <ImgWrap imgwidth="13.8" margintop="8.5">
              <img src={resultImg} alt="" />
            </ImgWrap>
          </Content>
        )}
        <Btns>
          <ButtonL
            onClick={() => {
              navigate("/amo/init");
            }}
          >
            확인
          </ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default AmoChangeResult;
const ResultInfo = styled.div`
  padding: 0.5rem 0 1.5rem 0;
  border-top: 1px dashed #919191;
  border-bottom: 1px dashed #919191;
  margin-top: 3rem;
  li {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    font-size: 1.4rem;
    font-style: normal;
    color: ${({ theme }) => theme.color.purple_primary};
    line-height: 2rem; /* 142.857% */
    letter-spacing: -0.42px;
  }
  .tx {
    width: 50vw;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
const LiTitle = styled.p`
  min-width: 13rem;
  font-weight: 700;
  color: ${({ theme }) => theme.color.black};
`;
